import { CellContext } from '@tanstack/react-table';
import { createSafeContext } from 'ui';

type RowActionMenuContext<
  TCellContext extends CellContext<any, unknown> = CellContext<any, unknown>,
> = {
  cellContext: TCellContext;
};
export const [RowActionMenuProvider, useRowActionMenu] = createSafeContext<RowActionMenuContext>(
  'Row action menu provider was not found in tree'
);
